import React from "react";

const ITEMS = [
  "DEMOLITION & STRIP-OUT",
  "PAINTING & DECORATING",
  "PLASTERING",
  "DRYWALL & PARTITIONS",
  "FLOORING & TILING",
  "CARPENTRY & DOORS",
  "REPAIRS & MAINTENANCE",
  "COMMERCIAL REFURBISHMENT",
  "RESIDENTIAL REFURBISHMENT",
  "LICENSED WASTE CARRIER",
  "FULLY INSURED",
  "FREE QUOTES",
];

export default function TrustTicker() {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="trust-ticker"
      className="bg-[#F5EFE5] border-y border-[#E5DDD0] overflow-hidden"
    >
      <div className="ticker flex whitespace-nowrap py-4">
        {loop.map((t, i) => (
          <div
            key={i}
            className="flex items-center gap-5 px-6 text-[11px] md:text-xs font-bold tracking-[0.3em] uppercase text-[#2B2420]"
          >
            <span>{t}</span>
            <span className="text-[#C9A24C]">◆</span>
          </div>
        ))}
      </div>
    </div>
  );
}
